import clsx from "clsx";
import { routes } from "../../routes";
import logo from "assets/logo.png";

export default function DesktopNav() {
  return (
    <div className={parentContainer}>
      <a href="/" className={imgContainer}>
        <img
          src={logo}
          alt="handwriting that says Violet Danse"
          className={imgStyle}
        />
        <img
          src={logo}
          alt="repeat of previous to make previous appear bolder"
          className={clsx(imgStyle + " mt-[2px]")}
        />
      </a>
      <div className="z-20">
        {routes.map(({ link, title }) => {
          const location = window.location.pathname;
          const selected = location === link;

          return (
            <a
              key={title}
              className={linkStyle + (selected && " ")}
              href={link}
            >
              {title}

              {selected && <div className={selectedLink} />}
            </a>
          );
        })}
      </div>
    </div>
  );
}

const parentContainer = clsx(
  "hidden lg:flex flex-col w-[300px] pl-20 justify-center bg-black/[98%] tracking-widest text-creme lowercase h-screen"
);
const imgContainer = clsx(
  "relative h-[120px] z-20 mb-10 flex items-center -mt-10 -ml-8"
);
const imgStyle = clsx("w-[160px] h-auto absolute invert");
const selectedLink = clsx("w-20 border-b-[1px] border-creme pt-2 -mb-2");
const linkStyle = clsx(
  "mb-12 flex flex-col uppercase tracking-widest text-sm hover:scale-[1.02] "
);
